<body class="bg-image">
  <app-appheader></app-appheader>
  <div class="container py-5">
    <router-outlet></router-outlet>
  </div>
  &nbsp;
  <br>
   <app-appfooter></app-appfooter>
  <script src="../assets/js/bootstrap.bundle.min.js"></script>
</body>